<template>
  <div class="search">
    <h2>"{{$route.query.k}}"相关的饲料原料目录搜索结果</h2>
    <!-- pc端 -->
    <el-table
      class="pc-show"
      v-loading="loading"
      :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
      :data="materialData"
      border
      stripe
      style="width: 100%">
      <el-table-column
        prop="ylcode"
        label="原料编号"
        min-width="10%">
      </el-table-column>
      <el-table-column
        prop="ENname"
        label="原料名称"
        min-width="20%">
        <template slot-scope="scope">
			<div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
          <!-- <router-link :to="{name: 'materialArticle', query:{itemid:scope.row.itemid}}"><div v-html="scope.row.title"></div></router-link> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="bsyq"
        label="强制性标识要求"
        min-width="25%">
        <template slot-scope="scope">
          <div v-html="scope.row.bsyq"></div>
        </template>
        </el-table-column>
      <el-table-column
        prop="content"
        label="特征描述"
        min-width="40%">
      </el-table-column>
    </el-table>
    <!-- 手机端 -->
    <el-table
      class="moblie-show"
      v-loading="loading"
      :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
      :data="materialData"
      border
      stripe
      style="width: 100%">
      <el-table-column
        prop="ylcode"
        label="原料编号"
        width="80">
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="ENname"
        label="原料名称"
        width="100">
        <template slot-scope="scope">
			<div v-html="scope.row.title" class="button-title" @click="toDetail(scope.row.itemid)"></div>
          <!-- <router-link :to="{name: 'materialArticle', query:{itemid:scope.row.itemid}}"><div v-html="scope.row.title"></div></router-link> -->
        </template>
      </el-table-column>
      <el-table-column
        prop="bsyq"
        label="强制性标识要求"
        width="100">
        <template slot-scope="scope">
          <div v-html="scope.row.bsyq"></div>
        </template>
        </el-table-column>
      <el-table-column
        prop="content"
        label="特征描述"
        width="200">
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current_page"
        :page-sizes="[10, 30, 50]"
        :page-size="per_page"
        layout="total, prev, pager, next, sizes, jumper"
        :total="total">
      </el-pagination>
    </div>

    <h2>"{{$route.query.k}}"相关的饲料添加剂品种目录搜索结果</h2>
    <!-- pc端 -->
    <el-table
    class="pc-show"
    v-loading="loading"
    :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
    :data="varietiesData"
    border
    stripe
    style="width: 100%">
    <el-table-column
      prop="catname"
      label="类别"
      min-width="15%">
    </el-table-column>
    <el-table-column
      prop="title"
      label="通用名称（中文）"
      min-width="30%">
      <template slot-scope="scope">
		  <div v-html="scope.row.title" class="button-title" @click="toDetail2(scope.row.itemid)"></div>
        <!-- <router-link :to="{name: 'varietiesArticle', query:{itemid:scope.row.itemid}}">{{scope.row.title}}</router-link> -->
      </template>
    </el-table-column>
    <el-table-column
      prop="en_title"
      label="通用名称（英文）"
      min-width="40%">
    </el-table-column>
    <el-table-column
      prop="fanwei"
      label="适用范围"
      min-width="15%">
    </el-table-column>
    </el-table>
    <!-- 手机端 -->
    <el-table
    class="moblie-show"
    v-loading="loading"
    :header-cell-style="{background:'rgba(248, 248, 248, 0.39)'}"
    :data="varietiesData"
    border
    stripe
    style="width: 100%">
    <el-table-column
      fixed="left"
      prop="catname"
      label="类别"
      width="150">
    </el-table-column>
    <el-table-column
      prop="title"
      label="通用名称（中文）"
      width="120">
      <template slot-scope="scope">
		  <div v-html="scope.row.title" class="button-title" @click="toDetail2(scope.row.itemid)"></div>
        <!-- <router-link :to="{name: 'varietiesArticle', query:{itemid:scope.row.itemid}}">{{scope.row.title}}</router-link> -->
      </template>
    </el-table-column>
    <el-table-column
      prop="en_title"
      label="通用名称（英文）"
      width="120">
    </el-table-column>
    <el-table-column
      prop="fanwei"
      label="适用范围"
      width="80">
    </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination
        background
        @size-change="handleNumChange"
        @current-change="handlePageChange"
        :current-page="current_page2"
        :page-sizes="[10, 30, 50]"
        :page-size="per_page2"
        layout="total, prev, pager, next, sizes, jumper"
        :total="total2">
      </el-pagination>
    </div>

  </div>

</template>

<script>
  export default {
    data() {
      return {
        materialData: [],
        varietiesData:[],
        current_page: 1,
        per_page: 10,
        total: 10,
        current_page2: 1,
        per_page2: 10,
        total2: 10,
        loading: true,

      }
    },
	watch: {
	    $route: "getPath",
	},
    created () {
      // 接收header传过来的k
      this.title = this.$route.query.k;
      // this.content = this.$route.query.k;
      // this.catid = this.$route.query.k;
      console.log(this.title)
      this.initMaterialData();
      this.initvarietiesData();
    },
    methods: {
	  getPath(){
		  this.title = this.$route.query.k;
		  console.log(this.title)
		  this.initMaterialData();
		  this.initvarietiesData();
	  },
    //原料
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.per_page = val
        this.initMaterialData();
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.current_page = val;
        this.initMaterialData();
      },
      initMaterialData(i){
        this.loading = true;
        this.per_page = i || this.per_page;
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=feed_ngredients_list&title=' + this.title ,{
          params: {
            title: this.title,
            content: this.content,
            catid: this.catid,
            page: this.current_page,
            num: this.per_page,
          }
        }).then(resp=>{
          this.loading = false ;
          if(resp){
            this.materialData = resp.data.data.data ;
            this.total = resp.data.data.total;
            console.log(resp.data.data.data);
          }
        })
      },
    //添加剂
      handleNumChange(val) {
        console.log(`每页 ${val} 条`);
        this.per_page2 = val
        this.initMaterialData();
      },
      handlePageChange(val) {
        console.log(`当前页: ${val}`);
        this.current_page2 = val;
        this.initMaterialData();
      },
      initvarietiesData(){
        this.$ajax.get('https://api.sy.foodvip.net/?c_key=de5cd2297c84684b&func_name=additive_list&title=' + this.title,{
          params: {
            title: this.title,
            fanwei: this.fanwei,
            catid: this.catid,
            page: this.current_page2,
            num: this.per_page2,
          }
        }).then(resp=>{
          if(resp){
            this.varietiesData = resp.data.data.data;
            this.total2 = resp.data.data.total;
            console.log(resp.data.data.data);
          }
        })
      },
	  toDetail(itemid){
	  	const routeUrl = this.$router.resolve({
	      name: 'materialArticle',
	      query: { itemid: itemid, current: 3 }
	    })
	    window.open(routeUrl.href, '_blank')
	  },
	  toDetail2(itemid){
	  	const routeUrl = this.$router.resolve({
	      name: 'varietiesArticle',
	      query: { itemid: itemid, current: 4 }
	    })
	    window.open(routeUrl.href, '_blank')
	  }
    },
  }
</script>

<style scoped>
.search{
  padding-bottom: 40px;
}
h2{
  font-size: 16px;
  line-height: 29px;
  color: #1966A7;
  text-align: left;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue